<div class="sidebar-wrapper-layout">
  <div class="sidebar-header">
    <a href="javascript:void(0)" class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle sidebar">
      <i class="material-icons sidebar-menu-icon" *ngIf="!isSidebarMini()">menu_open</i>
      <i class="material-icons sidebar-menu-icon" *ngIf="isSidebarMini()">menu</i>
      <img class="sidebar-logo" src="/assets/img/arl-logo-transparent.png" alt="ARL" />
    </a>
  </div>

  <div class="sidebar-scroll">
    <ul class="nav">
      <ng-container *ngFor="let menuItem of menuItems">
        <!-- Single Item -->
        <li routerLinkActive="active" *ngIf="!menuItem?.submenu && hasPermission(menuItem)" class="{{ menuItem.class }} nav-item"
          [attr.data-title]="menuItem.title">
          <a class="nav-link" [routerLink]="[menuItem.path]">
            <i class="material-icons">{{ menuItem.icon }}</i>
            <p>{{ menuItem.title }}</p>
          </a>
        </li>

        <!-- Item with Submenu -->
        <li *ngIf="menuItem?.submenu?.length > 0 && hasPermission(menuItem)" class="nav-item has-submenu"
          [ngClass]="{ active: isMenuItemActive(menuItem) }" [attr.data-title]="menuItem.title">
          <a class="nav-link" (click)="toggleMenuItem(menuItem)">
            <div class="menu-item">
              <i class="material-icons">{{ menuItem.icon }}</i>
              <p>{{ menuItem.title }}</p>
              <i class="material-icons submenu-icon">
                {{ menuItem.isSubMenuOpen ? "expand_less" : "expand_more" }}
              </i>
            </div>
          </a>
          <ul class="nav nav-submenu" *ngIf="menuItem.isSubMenuOpen || isSidebarMini()" [attr.data-parent]="menuItem.title">
            <li routerLinkActive="active"
              *ngFor="let subMenuItem of menuItem.submenu"
              class="nav-item"
              [attr.data-title]="subMenuItem.title">
              <a class="nav-link"
                *ngIf="sideBarUserRolespermissionCode?.includes(subMenuItem.permission)"
                [routerLink]="[subMenuItem.path]">
                <i class="material-icons">{{ subMenuItem.icon }}</i>
                <p>{{ subMenuItem.title }}</p>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="sidebar-footer">
    <ul class="nav">
      <li class="nav-item" routerLinkActive="active" data-title="Profile">
        <a class="nav-link" [routerLink]="['/main/user-profile']" aria-label="Profile">
          <i class="material-icons">account_circle</i>
          <p>Profile</p>
        </a>
      </li>
      <li class="nav-item" data-title="Logout">
        <a class="nav-link logout-link" href="javascript:void(0)" [class.logout-disabled]="logoutButtonDisable"
          (click)="!logoutButtonDisable && logout()" aria-label="Logout">
          <i class="material-icons">logout</i>
          <p>Logout</p>
        </a>
      </li>
    </ul>
  </div>
</div>